import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the challenge modal component.
 */
const useChallengeModalStyles = makeStyles()(() => ({
  modalStyles: {
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'center',
    'alignItems': 'center',
    'position': 'absolute',
    'top': '50%',
    'left': '50%',
    'transform': 'translate(-50%, -50%)',
    'width': '20vw',
    'minWidth': 'fit-content',
    'height': 'fit-content',
    'backgroundColor': colors.white,
    'padding': theme.padding.l,
    'borderRadius': theme.borderRadius.s,
    'border': 'none',
    'boxShadow': `2px 2px 5px 5px ${colors.gray['400']}`,
    '&:focus': {
      outline: 'none',
    },
  },
  challengeUser: {
    marginBottom: '20px',
  },
  challengeButton: {
    margin: '5px 0px 5px 0px',
    width: '100%',
  },
  cancelButton: {
    'background': colors.red['500'],
    'margin': '5px 0px 5px 0px',
    'marginTop': '25px',
    'border': 'none',
    'width': '100%',
    '&:hover': {
      backgroundColor: colors.red['600'],
    },
  },
  gameParrotIcon: {
    height: '200px',
    width: 'auto',
  },
}));

export default useChallengeModalStyles;
